// extracted by mini-css-extract-plugin
module.exports = {"message":"_17T9A_"};